import { DashboardLayout } from "@/components/layouts";
import { authMiddleware } from "@/middleware";
import { AdminBanners } from "@/pages/admin/banners";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/admin/banners/")({
	component: RouteComponent,
	loader: ({ location }) => authMiddleware(location.pathname),
});

function RouteComponent() {
	return (
		<DashboardLayout>
			<AdminBanners />
		</DashboardLayout>
	);
}
